import { render, staticRenderFns } from "./QuickInvoice.vue?vue&type=template&id=1284c67d&scoped=true"
import script from "./QuickInvoice.vue?vue&type=script&lang=js"
export * from "./QuickInvoice.vue?vue&type=script&lang=js"
import style0 from "./QuickInvoice.vue?vue&type=style&index=0&id=1284c67d&prod&scoped=true&lang=css"
import style1 from "./QuickInvoice.vue?vue&type=style&index=1&id=1284c67d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1284c67d",
  null
  
)

export default component.exports